/* eslint-disable no-console */

import bugsnag from "bugsnag-js";

// A wrapper around bugsnag.
//
// If you want to track errors on a particular page, you should
// import this module and call ErrorTrack.start() during the page
// object initialization.
//
// Calling ErrorTrack.start() will automatically capture a lot of
// interesting stuff.
//
// See https://docs.bugsnag.com/platforms/browsers/js/
//

export class CustomLogger {
  static debug(message) {
    if (process.env.NODE_ENV === "development") {
      console.debug(`[bugsnag] ${message}`);
    }
  }

  static error(message) {
    console.error(`[bugsnag] ${message}`);
  }

  static info(message) {
    console.info(`[bugsnag] ${message}`);
  }

  static warn(message) {
    console.warn(`[bugsnag] ${message}`);
  }
}

export default class ErrorTrack {
  static start(config = {}) {
    const configuration = Object.assign(config, { logger: CustomLogger });

    try {
      this.bugsnagClient = bugsnag(configuration);
    } catch (e) {
      console.warn("Bugsnag failed to start. Bad configuration?");
    }
  }

  static notify(exception) {
    if (this.bugsnagClient) {
      this.bugsnagClient.notify(exception);
    } else {
      console.warn("Bugsnag client not initialized! Call ErrorTrack.start() first.");
    }
  }
}
